import React, { useEffect } from "react";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { Col, Container, Row } from "react-bootstrap";
import ReactDOMServer from "react-dom/server";

import "./index.scss";
import TableLoading from "../TableLoading";
import {
  driverApprovedIcon,
  schoolIcon,
  boyStudent,
  girlStudent,
  boyStudentApproved,
  girlStudentApproved,
} from "./icons";
import boyStudentIcon from "./../../../assets/images/boy-student.png";
import girlStudentIcon from "./../../../assets/images/girl-student.png";
import {
  GENDER,
  GRADE,
  MARITAL,
  STUDENT_GENDER,
} from "../../values/dropdownItems";
import DriverInfoMap from "../../screen/DashboardScreen/components/Info.Driver";
import StudentInfoMap from "../../screen/DashboardScreen/components/Info.student";
import SchoolInfoMap from "../../screen/DashboardScreen/components/Info.School";

type props = {
  student?: any;
  driver?: any;
  school?: any;
  defaultLatArea?: any;
  defaultLngArea?: any;
  isLoading?: boolean;
  userType?: string;
  showStudent?: boolean;
  showDriver?: boolean;
  showSchool?: boolean;
};

const CustomLeafletMultiSpot: React.FC<props> = ({
  student,
  driver,
  school,
  defaultLngArea,
  defaultLatArea,
  isLoading,
  userType,
  showStudent,
  showDriver,
  showSchool,
}) => {
  /**
   *
   */
  const mapRef: any = React.createRef();

  if (userType === "COMPANY" && school) school = school![0];

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.setView([
        defaultLatArea || 36.92448,
        defaultLngArea || 50.64137,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLatArea, defaultLngArea]);

  const studentDescription = (
    avatar?: string,
    firstName?: string,
    lastName?: string,
    nationalCode?: string,
    grade?: string,
    field?: string,
    gender?: string,
    disability?: boolean
  ) =>
    ReactDOMServer.renderToStaticMarkup(
      <StudentInfoMap
        avatar={avatar}
        firstName={firstName}
        lastName={lastName}
        nationalCode={nationalCode}
        grade={grade}
        field={field}
        gender={gender}
        disability={disability}
      />
    );

  const driverDescription = (
    firstName?: string,
    lastName?: string,
    phoneNumber?: string,
    gender?: string,
    marital?: string,
    carSystem?: string,
    carColor?: string,
    companyName?: string,
    address?: string
  ) =>
    ReactDOMServer.renderToStaticMarkup(
      <DriverInfoMap
        firstName={firstName}
        lastName={lastName}
        phoneNumber={phoneNumber}
        gender={gender}
        marital={marital}
        carSystem={carSystem}
        carColor={carColor}
        companyName={companyName}
        address={address}
      />
    );

  const schoolDescription = (
    name?: string,
    telephone?: string,
    fullName?: string,
    phoneNumber?: string,
    address?: string
  ) =>
    ReactDOMServer.renderToStaticMarkup(
      <SchoolInfoMap
        name={name}
        telephone={telephone}
        fullName={fullName}
        phoneNumber={phoneNumber}
        address={address}
      />
    );
  return (
    <Container>
      <Row className="map-modal-container">
        <Col id="map-holder-multi">
          {isLoading && (
            <div className="loading">
              <div className="loading-container">
                <table>
                  <TableLoading />
                </table>
              </div>
            </div>
          )}
          <MapContainer
            ref={mapRef}
            center={[defaultLatArea || 35.715298, defaultLngArea || 51.404343]}
            zoom={12}
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {showStudent &&
              student &&
              student?.map((item: any, index: number) => (
                <Marker
                  key={"marker-location-" + index.toString()}
                  position={{
                    lat: item?.lat ? item?.lat : 36.92448,
                    lng: item?.lng ? item?.lng : 50.64137,
                  }}
                  icon={
                    item?.gender === "MALE"
                      ? item?.approved?.isApproved
                        ? boyStudent
                        : boyStudentApproved
                      : item?.approved?.isApproved
                      ? girlStudent
                      : girlStudentApproved
                  }
                  // eventHandlers={{
                  //   mouseover: (e) => {
                  //     e.target
                  //       .bindPopup(
                  //         studentDescription(
                  //           item?.avatar,
                  //           item?.firstName,
                  //           item?.lastName,
                  //           item?.nationalCode,
                  //           GRADE.find(
                  //             (gradeItem: any) => gradeItem._id === item?.grade
                  //           )?.name,
                  //           item?.field,
                  //           item?.gender,
                  //           item?.disability
                  //         )
                  //       )
                  //       .openPopup();
                  //   },
                  //   mouseout: (e) => {
                  //     e.target.closePopup();
                  //   },
                  // }}
                ></Marker>
              ))}
            {showDriver &&
              driver &&
              driver?.length >= 1 &&
              driver?.map(
                (item: any, key: number) =>
                  item?.driverLocation &&
                  item?.driver && (
                    <Marker
                      key={"marker-location-" + key.toString()}
                      position={{
                        lat: item?.driverLocation?.latitude,
                        lng: item?.driverLocation?.longitude,
                      }}
                      icon={driverApprovedIcon}
                      eventHandlers={{
                        mouseover: (e) => {
                          e.target
                            .bindPopup(
                              driverDescription(
                                item?.driver?.firstName,
                                item?.driver?.lastName,
                                item?.driver?.phoneNumber,
                                item?.driver?.gender,
                                item?.driver?.schoolDriverInformation?.marital,
                                item?.driver?.driverInformation?.carSystem,
                                item?.driver?.driverInformation?.carColor,
                                item?.driver?.schoolDriverInformation
                                  ?.companyName,
                                item?.driver?.schoolDriverInformation?.address
                              )
                            )
                            .openPopup();
                        },
                        mouseout: (e) => {
                          e.target.closePopup();
                        },
                      }}
                    ></Marker>
                  )
              )}
            {showSchool &&
              school &&
              school?.map((item: any, key: number) => (
                <Marker
                  key={"marker-location-" + key.toString()}
                  position={{
                    lat: item?.latitude,
                    lng: item?.longitude,
                  }}
                  icon={schoolIcon}
                  eventHandlers={{
                    mouseover: (e) => {
                      e.target
                        .bindPopup(
                          schoolDescription(
                            item?.name,
                            item?.telephone,
                            item?.fullName,
                            item.phoneNumber,
                            item.address
                          )
                        )
                        .openPopup();
                    },
                    mouseout: (e) => {
                      e.target.closePopup();
                    },
                  }}
                ></Marker>
              ))}
          </MapContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomLeafletMultiSpot;
